import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ACTIVE_STORY_KEY = "dw_active_story_id";

// Surfaces a "Story in progress" badge anywhere in the app by checking the same
// localStorage draft pointer the home generator writes, so parents notice a
// resumable background generation even before scrolling back to the generator.
export default function useActiveDraft(user) {
  const [draft, setDraft] = useState(null);
  const pollRef = useRef(null);

  useEffect(() => {
    if (!user) {
      setDraft(null);
      return;
    }
    const check = async () => {
      const sid = localStorage.getItem(ACTIVE_STORY_KEY);
      if (!sid) {
        setDraft(null);
        return;
      }
      try {
        const { data } = await axios.get(`${API}/stories/${sid}/generation-status`, { withCredentials: true });
        setDraft(data.status === "generating" ? { storyId: sid } : null);
      } catch (_) {
        setDraft(null);
      }
    };
    check();
    pollRef.current = setInterval(check, 4000);
    return () => clearInterval(pollRef.current);
  }, [user]);

  return draft;
}
